const port = {
  image: process.env.CDN_PORT + "/img",
  resume: process.env.CDN_PORT + "/resume",
};

export default port;
